import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=ea0fdfca&scoped=true"
import script from "./explain.vue?vue&type=script&lang=js"
export * from "./explain.vue?vue&type=script&lang=js"
import style0 from "./explain.vue?vue&type=style&index=0&id=ea0fdfca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0fdfca",
  null
  
)

export default component.exports